import axios from "axios";

const apiBaseUrl =
  process.env.REACT_APP_API_URL?.trim() || "http://localhost:8000";

const api = axios.create({
  baseURL: apiBaseUrl,
});

export default api;
